<!-- =========================================================================================
  File Name: ClientEditTabSettings.vue
  Description: Client Edit Tab Settings page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<style lang="scss">
.con-img-upload {
  background: #efeeee;
}
.custom-domain-wrap {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.input-wdt {
  width: 70%;
  margin-right: 15px;
}
.button-wrap {
  text-align: right;
}
.auth-check {
  width: 100%;
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
}
</style>
<template>
  <div id="client-edit-tab-settings">
    <h3 class="my-5">Default Options</h3>
    <div class="vx-row mb-6">
      <div class="vx-col md:w-1/1 w-full mt-4">
          <label class="mr-5 mt-2">Select Default Booth Template</label>
          <v-select
            class="w-full select-large"
            v-model="DefaultBoothTemplateId"
            :options="templateList"
            label="Name"
            :reduce="item=> item.id"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            name="DefaultBooths"
          />
      </div>

      <div class="vx-col md:w-1-12 w-full mt-5 button-wrap">
        <vs-button class="mb-2" @click="save_changes">Save</vs-button>
      </div>
    </div>
  </div>
</template>
<script>
import vSelect from "vue-select";
var vm;
export default {
  components: {
    vSelect
  },
  props: {
  },
  data() {
    return {
      templateList: [],
      DefaultBoothTemplateId: null
    };
  },

  methods: {
    save_changes() {
      // Here will go your API call for updating data
      // You can get data in "this.data_local"
      this.$vs.loading();
      /* eslint-enable */
      const Id = this.$route.params.clientId;
      if (Id) {
        this.$store
          .dispatch("clientManagement/updateDefaultOptions", {
            clientId: Id,
            DefaultBoothTemplateId: this.DefaultBoothTemplateId,
          })
          .then((res) => {
            this.$vs.notify({
              color: "success",
              title: "Client",
              text: res.message,
            });
            this.$vs.loading.close();
          })
          .catch((err) => {
            this.$vs.loading.close();
            console.error(err);
          });
      }
    },
    getBoothTemplates(){
      let clientId = this.$route.params.clientId;
      this.$vs.loading();
      this.$store
          .dispatch("clientManagement/fetchBoothTemplates")
          .then(res => { 
            this.$vs.loading.close();
            this.templateList = res;
            for(let tmp of this.templateList){
              if(tmp.ClientsDefault && tmp.ClientsDefault.includes(clientId))
                this.DefaultBoothTemplateId = tmp.id;
            }
          });
    }
  },
  created() {
    vm = this; 
    this.getBoothTemplates();
  },
};
</script>